import { render, staticRenderFns } from "./CarouselTile.vue?vue&type=template&id=3421ac1a&scoped=true&"
import script from "./CarouselTile.vue?vue&type=script&lang=js&"
export * from "./CarouselTile.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTile.vue?vue&type=style&index=0&id=3421ac1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421ac1a",
  null
  
)

export default component.exports